import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type { FeedbackRecord, FeedbackSubjectType } from '@erp/rpc';

export function useMyFeedbackForSubject(input: {
  subjectType: FeedbackSubjectType;
  subjectId: string;
  enabled?: boolean;
}) {
  const { subjectType, subjectId, enabled = true } = input;

  const query = useQuery({
    ...orpc.core.userFeedback.getMyForSubject.queryOptions({
      input: { subjectType, subjectId },
    }),
    enabled: enabled && !!subjectId,
  });

  return {
    ...query,
    feedbackByScoreName: (
      query.data as
        | { feedbackByScoreName: Record<string, FeedbackRecord> }
        | undefined
    )?.feedbackByScoreName,
  };
}
